import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HowItWorksDeepDive from '../features/landing/sections/HowItWorksDeepDive';
import HowItWorksHero from '../features/landing/sections/HowItWorksHero';
import HowItWorksCta from '../features/landing/sections/HowItWorksCta';

const HowItWorksPage: React.FC = () => {
    return (
        <div className="landing-shell">
            <Header />
            <main>
                <HowItWorksHero />
                <HowItWorksDeepDive />
                <HowItWorksCta />
            </main>
            <Footer />
        </div>
    );
};

export default HowItWorksPage;
